// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1EknP","title":"FrontImage_title__RxHkx"};